<style type="text/css" lang="stylus">
@import '../config/var-css'
  .title-bar
    position fixed
    width 100%
    max-width rem(750)
    margin 0 auto
    left 0
    right 0
    padding rem(26)
    box-sizing border-box
    text-align center
    background-color #373737
    color $white
    z-index 100
    h3
      font-size $font-size-large-x
      line-height rem(48)
  .title-close
    position fixed
    left 0
    top 0
    width rem(100)
    height rem(100)
    z-index 200
    line-height rem(100)
    text-align center
  // .icon-arrow-lb
  //   float left
  //   position absolute
  //   top 50%
  //   left rem(20)
  //   font-size rem(44)
  //   margin-top rem(-22)
  .titlebar-bottom
    padding-top rem(98)
</style>
<template>
  <div v-show="isShow" class="titlebar-root">
    <div class="title-bar">
      <div class="title-close" @click="go">
        <i class="icon-arrow-lb dmx-iconfont dmx-icon-back"></i>
      </div>
      <h3 v-text="barTitle">
      </h3>
    </div>
    <div class="titlebar-bottom"></div>
  </div>
</template>
<script type="text/javascript">
  import { mapState, mapMutations } from 'vuex'
  import Channel from '@/config/channel'
  import Vue from 'vue'
  export default {
    props: {
      'title': {
        type: String,
        default: ''
      },
      'goBack': {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapState({
        isShow: state => state.titlebar.showHeader,
      }),
      barTitle: {
        get () {
          let title = Vue.cookie('portal') !== 'rongyitui' ? this.title: '百花信风'
          // 20210317 这里是接融易推的时候走的hangban的标题,但是我方法务要求改成百花信风,所以万般无奈之下只能在这儿改了,见谅.
          // lingjuan.guan
          return title
        },
        set (val) {
          this.updateTitle(val)
        }
      }
    },
    methods: {
      ...mapMutations({
        'updateTitle': 'UPDATE_TITLE',
        'updateTitleShow': 'UPDATE_TITLE_SHOW',
      }),
      go: function () {
        if (this.$route.name == 'supplement/identity') {
          Vue.sensorsTrack("CancelApplication", {
            cancel: true,
            current_page: '上传身份证'
          })
        } else if (this.$route.name == 'supplement/vendor') {
          Vue.sensorsTrack("CancelApplication", {
            cancel: true,
            current_page: '信息补充'
          })
        }
        if (Vue.cookie('loanurl')) {
          window.location.replace(decodeURIComponent(Vue.cookie('loanurl')))
        } else {
          if (this.goBack) {
            window.history.go(-1);
          }
          this.$emit('goBack');
        }
      }
    },
    mounted () {
      this.barTitle = Vue.cookie('portal') !== 'rongyitui' ? this.$dmt('titlebar'): this.$dmt('rongyituiBar')
      this.updateTitle(this.barTitle)

      if (Vue.cookie('whh') == 1 || Vue.cookie('applyID') || Vue.cookie('skin') == 'yunxinIOS') {
        this.updateTitleShow(false);
      } else {
        this.updateTitleShow(!Channel.isHiddenTitle());
      }
    }
  }
</script>
